import axios from 'axios'

const API_URL = process.env.API_URL

const DEFAULT_HEADERS: Record<string, string> = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

const instance = axios.create({
  baseURL: API_URL,
  headers: DEFAULT_HEADERS,
})

instance.interceptors.response.use(
  (resp) => {
    return resp
  },
  (err) => {
    const errObj = {
      error: true,
      Message: '',
      pending: false,
    }
    if (err.response && err.response.data) {
      errObj.Message = err.response.data
    } else if (err.request) {
      errObj.Message = 'Problem connecting to server.'
    } else {
      errObj.Message = err.message
    }
    return Promise.reject(errObj)
  }
)

export const URLS = {
  // AUTH
  SIGN_IN: 'authentication/login',
  SIGN_UP: 'authentication/signup',
  USER_INFO: 'user',
  CHECK_SESSION_HASH: 'authentication/isauthenticated',
  REQUEST_RESET_PASSWORD: 'authentication/request-password-reset',
  RESET_PASSWORD: 'authentication/reset-password',

  // CHARITY
  GET_CHARITIES: 'charity/all',
  GET_AVAILABLE_CHARITIES: 'charity/availableCharities',
  GET_CHARITY_BY_ID: 'charity/byid',
  CREATE_PAYMENT_INTENT: 'payments/intent',
  CREATE_P2P_PAYMENT_INTENT: 'payments/p2p-event',

  // JUST_GIVING_PAYMENTS
  JG_CREATE_PAYMENT: 'payments/create',
  JG_UPDATE_PAYMENT: 'payments/update',

  // EVENTS
  GET_EVENT_BY_ID: 'events/byid',
  JOIN_EVENT: 'events/join',
  GET_EVENT_MERCH: 'events/admission',
  GET_EVENT_TEAMS: 'events/public/teams',

  //V2_JOIN
  V2_EVENT_JOIN: 'v2/events/join',

  // JUST_GIVING_EVENTS_REGISTRATION
  JS_REGISTER_EVENT: 'registration/create',
  JS_REGISTER_EVENT_UPDATE: 'registration/update',

  // MY PARTICIPATIONS
  GET_PARTICIPATIONS: 'events/my-participation',

  // PRICE TIERS
  // DEPRECATED
  //GET_PRICE_TIERS: 'challenges/admission',
  GET_PRICE_TIERS: 'events/admission',

  // PAYMENT
  SET_BILLING_INFO: 'payments/billing-info',

  // SHIPPING
  SET_SHIPPING_INFO: 'shipping/merch-orders/create',
}

export default instance
